import { render, staticRenderFns } from "./PointOnMap.vue?vue&type=template&id=4e5ad48c"
import script from "./PointOnMap.vue?vue&type=script&lang=js"
export * from "./PointOnMap.vue?vue&type=script&lang=js"
import style0 from "./PointOnMap.vue?vue&type=style&index=0&id=4e5ad48c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports